import { useEffect, useRef, useState } from "react";
import { useMutation, useQuery } from "react-query";
import HeaderBar from "../../../Components/UI/headerbar";
import CuriorInfo from "../../../Components/curiors/store/curiorInfo";
import { getZones } from "../../../MyApi/zones";

import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";

import CoveringZoneInfo from "../../../Components/curiors/store/coveringzoneInfo";
import DeliveringInfo from "../../../Components/curiors/store/delvieringInfo";
import Attachments from "../../../Components/curiors/store/delvieringInfo/attachments";
import VehicleInfo from "../../../Components/curiors/store/vehicleInfo";
import { postCurios, showCurios, updateCurios } from "../../../MyApi/curior";
import LoadingSpinner from "../../../Components/UI/spinner";
import Button from "../../../Components/UI/buttonGlobal";
import { formatPrice } from "../../../utils/formatPrice";
import i18next from "i18next";
import { curieorSchema } from "./schema";


const CuriorStorePage = ({ mode = "add", id }) => {
  const [searchParams] = useSearchParams();
  const storeParam = searchParams.get("store_id");
  const location =useLocation()
  const [checkPlateNumber, setCheckPlateNumber] = useState("");
  const lang = i18next.language;
  const [selectedLangCode, setSelectedLangCode] = useState(lang);
  const { data, isLoading } = useQuery(
    ["showCurios", id, selectedLangCode],
    () => showCurios(id, selectedLangCode),
    {
      enabled: !!id && mode === "edit",
    },
  );
  const curior = data?.data?.couier || {};

  const [currencyFactor, setCurrencyFactor] = useState("");
  const [curiorInfo, setCuriorInfo] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    phone_code: "+963",
    iban: "",
    license_number: "",
    status: "active",
    store_id: "",
    birthday: "",
    commission_type: "",
    commission_amount: "",
    avatar: "",
    driving_license: "",
    is_active: 1,
  });

  const [addressInfo, setAddressInfo] = useState({
    zone_id: "",
    latitude: null,
    longitude: null,
    address_line_1: "",
    country_id: "",
    governorate_id: "",
    city_id: "",
  });
  const [zones_to_cover, setZonesToCover] = useState([]);
  const [vehicle, setVehicle] = useState({
    plate_number: "",
    color: "",
    model: "",
    vehicle_id: "",
    car_license: "",
  });
  const [nationalID, setNationalID] = useState({
    front_image: "",
    back_image: "",
    national_id: "",
  });

  const [attachments, setAttachments] = useState([{ id: 0 }]);
  const [area, setArea] = useState([]);
  const [locations, setLocations] = useState(null);

  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    if (mode === "edit" && curior?.id) {
      setCuriorInfo({
        first_name: curior?.first_name || "",
        last_name: curior?.last_name || "",
        email: curior?.email || "",
        phone: curior?.phone || "",
        phone_code: curior.phone_code,

        license_number: curior.license_number || "",
        status: curior?.status || "active",
        store_id: curior?.store?.id || "",
        store: curior?.store || {},
        birthday: curior?.birthday || "",
        commission_type: curior?.commission_type,
        commission_amount: formatPrice(
          curior?.zones[0]?.currency_factor,
          curior.commission_amount,
        ),
        avatar: curior?.avatar || "",
        driving_license: curior?.driving_license || "",
        is_active: curior?.status === "active" ? 1 : 0,
      });
      setCurrencyFactor(curior?.zones[0]?.currency_factor);

      if (curior.address) {
        setAddressInfo({
          country_id: curior?.address.country?.id,
          governorate_id: curior?.address.governorate?.id,
          city_id: curior?.address.city?.id || "",
          zone_id: curior?.address.zone?.id || "",
          latitude: curior?.address.latitude || "",
          longitude: curior?.address.longitude || "",
          address_line_1:
            curior?.address.address_line_1 || curior?.address.street || "",
        });
      }

      if (curior.vehicle) {
        setVehicle({
          plate_number: curior?.vehicle.plate_number || "",
          color: curior?.vehicle.color || "",
          model: curior?.vehicle.car_model || "",
          vehicle_id: curior?.vehicle.vehicle?.id || "",
          car_license: curior?.vehicle.car_license || "",
        });
      }
      setCheckPlateNumber(curior?.vehicle.plate_number);

      if (Array.isArray(curior?.zones)) {
        setZonesToCover(curior?.zones.map((z) => z.id));
      }

      if (Array.isArray(curior?.attachments)) {
        setAttachments(curior?.attachments);
      }
      setNationalID((prev) => ({
        ...prev,
        front_image: curior?.national_identity?.front_image,
        back_image: curior?.national_identity?.back_image,
        national_id: curior?.national_identity?.national_id,
      }));
    }
  }, [mode, data]);
  const prevZoneRef = useRef(null);

  const { data: zonesData } = useQuery("getZones", getZones);

  const zones = zonesData?.data?.zones ?? [];

  useEffect(() => {
    if (locations) {
      setAddressInfo((prev) => ({
        ...prev,
        latitude: locations.lat,
        longitude: locations.long,
      }));
    }
  }, [locations]);
  useEffect(() => {
    if (!prevZoneRef.current) {
      // first mount (edit load)
      prevZoneRef.current = addressInfo.zone_id;
      return;
    }

    if (prevZoneRef.current !== addressInfo.zone_id) {
      // real change by user
      setAddressInfo((prev) => ({
        ...prev,
        latitude: null,
        longitude: null,
      }));
    }

    prevZoneRef.current = addressInfo.zone_id;
  }, [addressInfo.zone_id]);

  useEffect(() => {
    if (addressInfo) {
      const selectedZone =
        zones.find((zone) => zone.id === addressInfo.zone_id) || [];

      setArea(selectedZone.area);
    }
  }, [addressInfo.zone_id, zones]);

  useEffect(() => {
    if (storeParam) {
      setCuriorInfo((prev) => ({ ...prev, store_id: Number(storeParam) }));
    }
  }, [storeParam]);

  const steps = [
    { id: 1, key: "personal_info", title: " المعلومات الشخصية", icon: 1 },
    { id: 2, key: "zones_to_cover", title: "المناطق المغطاه", icon: 2 },
    { id: 3, key: "vechical", title: "تفاصيل المركبة", icon: 3 },
    {
      id: 4,
      key: "delivery",
      title: " طريقة الحساب التوصيل",
      icon: 4,
    },
    { id: 5, key: "confirm", title: "تأكيد البيانات", icon: 5 },
  ];

  const [activeTab, setActiveTab] = useState("personal_info");
  const currentStep = steps.findIndex((s) => s.key === activeTab) + 1;
  const progress = (currentStep / steps.length) * 100;
  const navigate = useNavigate();
  // Queries

  const mutation = useMutation({
    mutationKey: ["postCurios"],
    mutationFn: (postData) => postCurios(postData),
    onSuccess: (data) => {       
      toast.success(`${data.message}`);
      navigate(`${process.env.PUBLIC_URL}/drivers`);
    },
    onError: (error) => {
      toast.error(`${error.response?.data?.message}`);
    },
  });

  const updateMutation = useMutation({
    mutationKey: ["updateCurior"],
    mutationFn: (postData) => updateCurios(postData, id),
    onSuccess: (data) => {
      toast.success(`${data.message}`);     
      navigate(`${process.env.PUBLIC_URL}/drivers`);       
    },         
    onError: (error) => {
      toast.error(`${error.response?.data?.message}`);
    },
  });
  const handleAddPostRequest = () => {
    const formData = new FormData();

    Object.entries(curiorInfo).forEach(([key, value]) => {
      if (
        (key === "avatar" || key === "driving_license") &&
        !(value instanceof File)
      ) {
        return;
      }
      formData.append(`courier[${key}]`, value);
    });

    Object.entries(addressInfo).forEach(([key, value]) => {
      if (value) formData.append(`address[${key}]`, value);
    });

    zones_to_cover.forEach((zone, i) => {
      formData.append(`zones_to_cover[${i}]`, zone);
    });

    Object.entries(vehicle).forEach(([key, value]) => {
      if (key === "car_license" && !(value instanceof File)) {
        return;
      }
      if (key === "plate_number" && checkPlateNumber === value) {
        return;
      }
      if (value) formData.append(`vehicle[${key}]`, value);
    });
    Object.entries(nationalID).forEach(([key, value]) => {
      if (value === null || value === undefined || value === "") return;

      if (
        (key === "front_image" || key === "back_image") &&
        !(value instanceof File)
      ) {
        return;
      }

      formData.append(`nationalID[${key}]`, value);
    });

    attachments.forEach((attach, i) => {
      if (attach.url && !(attach.url instanceof File)) {
        return;
      } else {
        if (!attach.file) return;
        formData.append(`attachment[${i}][name]`, attach.name);
        formData.append(`attachment[${i}][path]`, attach.file);
      }
    });
    if (mode === "edit") {
      formData.append("lang", "ar");
      formData.append("_method", "PUT");
      updateMutation.mutate(formData);
    } else {
      const payload = {
        ...curiorInfo,
        ...addressInfo,
        ...attachments,
        ...nationalID,
        ...vehicle,
        commission_amount: curiorInfo.commission_amount,
        store_id: curiorInfo.store_id,
      };
    console.log('payload', payload)
      const result = curieorSchema.safeParse(payload);

      if (!result.success) {
        const errors = mapZodErrors(result.error.issues);
        setFormErrors(errors);
        toast.error("من فضلك راجع البيانات");
        return;
      }
      console.log("result", result);
      mutation.mutate(formData);
    }
  };

  const mapZodErrors = (zodError) => {
    const errors = {};
    console.log("zodError", zodError);
    zodError.forEach((err) => {
      const field = err.path[0]; // اسم الحقل
      errors[field] = err.message;
    });

    return errors;
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    console.log("name", name, value);
    setFormErrors((prev) => ({
      ...prev,
      [name]: validateField(name, value),
    }));
  };

  const validateField = (field, value) => {
    const fieldSchema = curieorSchema.shape[field];
    if (!fieldSchema) return "";

    const result = fieldSchema.safeParse(value);
    console.log("result", result);
    return result.success ? "" : result.error.errors[0].message;
  };

  const handleNext = () => {
    const currentIndex = steps.findIndex((s) => s.key === activeTab);
    if (currentIndex < steps.length - 1) {
      setActiveTab(steps[currentIndex + 1].key);
    }
  };

  const handlePrev = () => {
    const currentIndex = steps.findIndex((s) => s.key === activeTab);
    if (currentIndex > 0) {
      setActiveTab(steps[currentIndex - 1].key);
    }
  };

  if (isLoading && mode === "edit") {
    return <LoadingSpinner />;
  }
  return (
    <div>
      <HeaderBar
        title={mode === "edit" ? "تعديل السائق" : "إضافة سائق جديد"}
        content={mode === "edit" ? "تعديل السائق لدايم" : "أضف سائق جديد لشركتك"}
        isBack={true}
        isEdit={mode === "edit"}
        setSelectedLangCode={setSelectedLangCode}
        selectedLangCode={selectedLangCode}
      />
      <div className="container">
        <div className="card rounded-4">
          <div className="card-body">
            <div
              className="position-relative mt-3 mb-3"
              style={{ height: "40px" }}
            >
              {/* Progress bar */}

              {/* Steps circles */}
              <div className="d-flex justify-content-between align-items-center position-absolute top-0 start-0 w-100 translate-middle-y">
                {steps.map((s) => (
                  <div
                    key={s.id}
                    className="d-flex align-items-center justify-content-center rounded-circle"
                    style={{
                      width: "40px",
                      height: "40px",
                      zIndex: "10",
                      backgroundColor:
                        currentStep >= s.id ? "#FFCC03" : "#E6E6E6",
                      color: "#fff",
                      fontWeight: "bold",
                    }}
                  >
                    {s.id}
                  </div>
                ))}
                <div
                  className="progress position-absolute  start-0 w-100 "
                  style={{ height: "12px", top: "40%" }}
                >
                  <div
                    className="progress-bar bg-primary"
                    role="progressbar"
                    style={{ width: `${progress}%` }}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-between mt-2 mb-3">
              {steps.map((s) => (
                <small
                  key={s.id}
                  className={`${
                    currentStep >= s.id ? "text-success fw-bold" : "text-muted"
                  } font14`}
                >
                  {s.title}
                </small>
              ))}
            </div>

            <div className="row add">
              {(activeTab === "personal_info" || activeTab === "confirm") && (
                <>
                  <CuriorInfo
                    setCuriorInfo={setCuriorInfo}
                    curiorInfo={curiorInfo}
                    setAddressInfo={setAddressInfo}
                    addressInfo={addressInfo}
                    nationalID={nationalID}
                    setNationalID={setNationalID}
                    mode={mode}
                    formErrors={formErrors}
                    handleBlur={handleBlur}
                  />
                </>
              )}

              {(activeTab === "zones_to_cover" || activeTab === "confirm") && (
                <CoveringZoneInfo
                  zones={zones}
                  zones_to_cover={zones_to_cover}
                  setZonesToCover={setZonesToCover}
                  setCuriorInfo={setCuriorInfo}
                  addressInfo={addressInfo}
                  setAddressInfo={setAddressInfo}
                  area={area}
                  setArea={setArea}
                  locations={locations}
                  setLocations={setLocations}
                  formErrors={formErrors}
                />
              )}
              {(activeTab === "vechical" || activeTab === "confirm") && (
                <VehicleInfo
                  vehicle={vehicle}
                  setVehicle={setVehicle}
                  setCuriorInfo={setCuriorInfo}
                  curiorInfo={curiorInfo}
                  formErrors={formErrors}
                />
              )}
              {(activeTab === "delivery" || activeTab === "confirm") && (
                <>
                  <DeliveringInfo
                    currencyFactor={currencyFactor}
                    setCuriorInfo={setCuriorInfo}
                    curiorInfo={curiorInfo}
                    attachments={attachments}
                    setAttachments={setAttachments}
                    formErrors={formErrors}
                  />

                  {attachments.map((attach, i) => (
                    <Attachments
                      key={attach.id}
                      attach={attach}
                      i={i}
                      setAttachments={setAttachments}
                      attachments={attachments}
                    />
                  ))}
                </>
              )}
              {activeTab !== "confirm" && (
                <div className="col-4 mt-3 d-flex align-items-center gap-2 mt-2">
                  <button className="btn btn-white" onClick={handlePrev}>
                    السابق
                  </button>
                  <button className="btn btn-primary" onClick={handleNext}>
                    التالي
                  </button>
                </div>
              )}
              {activeTab === "confirm" && (
                <div className="col-4 mt-3 d-flex align-items-center gap-2 mt-2">
                  <Button
                    className={"btn-primary"}
                    onClick={handleAddPostRequest}
                    label={
                      mode === "edit" ? "تعديل سائق" : " تأكيد وإضافة سائق"
                    }
                    disabled={mutation.isLoading || updateMutation.isLoading}
                    isLoading={mutation.isLoading || updateMutation.isLoading}
                  ></Button>

                  <button className="btn btn-white" onClick={handlePrev}>
                    السابق
                  </button>
                  <button
                    className="btn btn-white"
                    onClick={() => navigate(-1)}
                  >
                    إلغاء
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CuriorStorePage;
